import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ForYou() {
  const items = ['Sos recruiter, selector o consultor de talento.', 'Manejás varias búsquedas al mismo tiempo.', 'Sentís que cada búsqueda se te desordena.', 'Revisás muchos CVs y perdés tiempo filtrando perfiles que no encajan.', 'Buscás un sistema práctico, simple y aplicable desde el primer día.'];
  return <section className="py-24 bg-white" data-id="element-67">
      <div className="max-w-4xl mx-auto px-6" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-slate-900" data-id="element-70">
            ESTE KIT ES PARA VOS SI...
          </h2>
        </motion.div>

        <div className="bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-100 shadow-sm" data-id="element-71">
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-6" data-id="element-72">
            {items.map((item, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05
          }} className="flex items-start gap-4" data-id="element-73">
                <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-74">
                  <Check className="w-4 h-4 text-emerald-600" data-id="element-75" />
                </div>
                <p className="text-slate-700 font-medium leading-relaxed" data-id="element-76">
                  {item}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}